export const buttonVariants = ['primary', 'secondary', 'text', 'custom'] as const;
export const buttonColors = ['primary', 'info', 'success', 'error', 'warning', 'neutral'] as const;
export type ButtonVariant = (typeof buttonVariants)[number];
export type ButtonColor = (typeof buttonColors)[number];

export type Sizes = 'xsmall' | 'small' | 'medium' | 'large';
export const sizes: Record<Sizes, string> = {
  xsmall: '28px',
  small: '36px',
  medium: '44px',
  large: '52px',
};
